// Complementary, proportional windows following the two joins in Pépin's
// reviewed 1254px master. These windows reveal photographs; they create no RGB.
const firstJoin = [[0,25.12],[31.9,25.04],[39.87,24.72],[47.85,24.64],
  [55.82,25.2],[63.8,25.28],[71.77,25.44],[100,25.44]];
const secondJoin = [[0,49.28],[31.9,49.28],[39.87,49.12],[47.85,49.6],
  [55.82,49.52],[63.8,49.68],[71.77,49.6],[100,49.68]];
const polygon = points => `polygon(${points.map(([x,y]) => `${x}% ${y}%`).join(',')})`;
export const pepinBandWindows = Object.freeze({
  top:polygon([[0,0],[100,0],...firstJoin.slice().reverse()]),
  middle:polygon([...firstJoin,...secondJoin.slice().reverse()]),
  bottom:polygon([...secondJoin,[100,74.2],[0,74.2]]),
  stick:'inset(74.2% 0 0)',
});

// One atlas per colour is reused in every band. Never substitute another
// colour when an exact source is missing. The original face remains in each
// lower-band photograph; the separate stick and silhouette never change.
export function photographicBandScene({library,top,middle,bottom,ribbonFabric}) {
  const bodyIds={top:top?.option_id,middle:middle?.option_id,bottom:bottom?.option_id};
  const ribbon=library?.ribbons?.[ribbonFabric?.option_id];
  if(!library?.master?.src||!library.windows||!ribbon?.src||
    Object.values(bodyIds).some(id=>!library.colours?.[id]?.src))return null;
  return {
    body:library.master.src,
    bodyMask:library.master.src,
    bodyIds,
    bodyPanels:[...Object.entries(bodyIds).map(([id,colour])=>({
      id,src:library.colours[colour].src,clipPath:library.windows[id],
    })),{id:'stick',src:library.master.src,clipPath:library.windows.stick}],
    ribbon:ribbon.src,
    ribbonId:ribbonFabric.option_id,
    bodyPlacement:{...library.bodyPlacement},
    ribbonPlacement:{...library.ribbonPlacement,...ribbon.placement},
  };
}
